export default {
    // cart templates
    cartQuickViewAddConfirmation: require( './cart/cartQuickViewAddConfirmation.html' ),
    cartQuickViewItemDetail: require( './cart/cartQuickViewItemDetail.html' ),
    cartQuickViewLayout: require( './cart/cartQuickViewLayout.html' ),
    cartSummaryShippingMsg: require( './cart/cartSummaryShippingMsg.html' ),
    cartQuickViewSummary: require( './cart/cartQuickViewSummary.html' ),

    // products
    recommendationsCrossSell: require( './products/recommendationsCrossSell.html' ),

    // may account
    orderHistoryItem: require( './myaccount/orderHistoryItem.html' ),

    // dialogs
    messagebox: require( './dialogs/messagebox.html' ),
    backorderPolicy: require( './dialogs/backorderPolicy.html' ),
    lgpOrderApprovalDialog: require( './dialogs/lgpOrderApprovalDialog.html' ),

    // photo gallery
    galleryImageViewer: require( './photogallery/galleryImageViewer.html' ),
    galleryImageViewerMarketingMaterials: require( './photogallery/galleryImageViewerMarketingMaterials.html' ),
    gallerySlideController: require( './photogallery/gallerySlideController.html' ),
    galleryThumbController: require( './photogallery/galleryThumbController.html' ),

    // page components
    addressBook: require( './pagecomponents/addressBook.html' ),
    orderStatusBadge: require( './pagecomponents/orderStatusBadge.html' ),
    filterForm: require( './pagecomponents/filterForm.html' )
};
